import React from 'react';
import PropTypes from 'prop-types';
import { Stack, mergeStyles, Spinner, SpinnerSize } from '@bingads-webui-react/fabric-control';

const blockUiContainer = mergeStyles({
  position: 'absolute',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  zIndex: 1010,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  height: '100%',
  cursor: 'wait',
});

const blockUiOverlay = mergeStyles({
  width: '100%',
  height: '100%',
});

const reactBlockUi = mergeStyles({
  position: 'relative',
  minHeight: '2em',
});

export const UiBlocker = (props) => {
  const {
    blocking,
    children,
    loadingText,
  } = props;

  return (
    <div className={reactBlockUi} aria-busy={blocking}>
      {children}
      {blocking &&
        <div className={blockUiContainer}>
          <div className={blockUiOverlay}>
            <Stack verticalAlign="center" horizontalAlign="center" styles={{ root: { width: '100%', height: '100%' } }}>
              <Spinner size={SpinnerSize.large} label={loadingText} labelPosition="right" />
            </Stack>
          </div>
        </div>
      }
    </div>
  );
};

UiBlocker.propTypes = {
  blocking: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  loadingText: PropTypes.string.isRequired,
};
